export const microreelsLibraryText = {
  title: 'Microreels',
  select: 'Select',
  reelCopied: 'Microreel copied successfully',
  reelsCopied: 'Microreels copied successfully',
  emptyTitle: 'No microreels yet',
  emptySubtitle: 'Published microreels will appear here.',
};
